import { c as _c } from "react/compiler-runtime";
import { LazySection } from "@/components/common/lazy-section";
import { NearbySUPsClient } from "@/components/nearby-sups/client";
import { LazyNearbyPlacesMap } from "@/components/project-or-sup/lazy-nearby-places-map";
import { AvailableSUPs } from "@/components/projects/available-sups";
import { NearbySupsSkeleton } from "@/components/projects/skeletons";
import { ProjectTitle } from "@/components/projects/title";
import { AdditionalFeatures } from "@/components/sup/additional-features";
import { GalleryLarge } from "@/components/sup/gallery/large";
import { GallerySmall } from "@/components/sup/gallery/small";
import { AmenitiesSection } from "@/components/sup/sections/amenities";
import { ProjectDetails } from "@/components/sup/sections/project-details";
import { SectionContent } from "@/components/sup/seller-unit/section-components";
import { NearbyProperty } from "@/types/sup";
import { ProjectPageData } from "@/utils/get-project-data";
import { toSentenceCase } from "@/utils/string/to-sentence-case";
import { PromotionalCardsSection } from "../promotional-cards/hooks";
interface ProjectSectionsProps {
  projectData: ProjectPageData;
  coordinates?: {
    lat: number;
    lng: number;
  };
  nearByProjects: NearbyProperty[];
  id: string;
  categories: {
    name: string;
    code: string;
  }[];
}
export function ProjectSections(t0) {
  const $ = _c(121);
  const {
    projectData,
    coordinates,
    nearByProjects,
    id,
    categories
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    t2 = [];
    t3 = [];
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  const t4 = projectData.images?.[0]?.url || "";
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [];
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = new Date();
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== projectData.projectInfo.approvals) {
    t7 = projectData.projectInfo.approvals ? projectData.projectInfo.approvals.split(", ") : [];
    $[5] = projectData.projectInfo.approvals;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== projectData.projectInfo.documents) {
    t8 = projectData.projectInfo.documents ? projectData.projectInfo.documents.split(", ") : [];
    $[7] = projectData.projectInfo.documents;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== projectData.projectInfo.bankApprovals) {
    t9 = projectData.projectInfo.bankApprovals ? projectData.projectInfo.bankApprovals.split(", ") : [];
    $[9] = projectData.projectInfo.bankApprovals;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== projectData.amenities) {
    t10 = projectData.amenities?.map(_temp) ?? [];
    $[11] = projectData.amenities;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = [];
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  const t12 = projectData.ageStatus?.label === "Age" ? "Ready to move" : "UnderConstruction";
  let t13;
  if ($[14] !== t12) {
    t13 = [t12];
    $[14] = t12;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== projectData.id || $[17] !== projectData.location || $[18] !== projectData.name || $[19] !== projectData.projectInfo.blocks || $[20] !== projectData.projectInfo.maxFloors || $[21] !== projectData.projectInfo.units || $[22] !== t10 || $[23] !== t13 || $[24] !== t4 || $[25] !== t7 || $[26] !== t8 || $[27] !== t9) {
    t14 = {
      _id: projectData.id,
      bathrooms: t1,
      bedrooms: t2,
      builtUpAreas: t3,
      cover: t4,
      distance: 0,
      prices: t5,
      type: "sp" as const,
      updatedAt: t6,
      locality: projectData.location,
      localityName: projectData.location,
      projectName: projectData.name,
      projectId: projectData.id,
      approvals: t7,
      documents: t8,
      bankApprovals: t9,
      amenities: t10,
      totalBlocks: projectData.projectInfo.blocks,
      totalFloors: projectData.projectInfo.maxFloors,
      totalUnits: projectData.projectInfo.units,
      configurations: t11,
      possessionStatuses: t13
    };
    $[16] = projectData.id;
    $[17] = projectData.location;
    $[18] = projectData.name;
    $[19] = projectData.projectInfo.blocks;
    $[20] = projectData.projectInfo.maxFloors;
    $[21] = projectData.projectInfo.units;
    $[22] = t10;
    $[23] = t13;
    $[24] = t4;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  const projectSupOne = t14;
  let t15;
  if ($[29] !== id || $[30] !== projectData.location || $[31] !== projectData.name || $[32] !== projectSupOne) {
    t15 = <ProjectTitle name={projectData.name} location={projectData.location} projectId={id} supOne={projectSupOne} />;
    $[29] = id;
    $[30] = projectData.location;
    $[31] = projectData.name;
    $[32] = projectSupOne;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== categories || $[35] !== projectData.id || $[36] !== projectData.images) {
    t16 = <div className="@4xl:hidden mt-4 grid mb-3 h-[300px] -mx-2"><GallerySmall mediaList={projectData.images} className="" projectId={projectData.id} shouldPrioritizeCoverImage={true} sizes="(max-width: 480px) 100vw, (max-width: 768px) 80vw, 600px" categories={categories} /></div>;
    $[34] = categories;
    $[35] = projectData.id;
    $[36] = projectData.images;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== categories || $[39] !== projectData.id || $[40] !== projectData.images) {
    t17 = <div className="hidden @4xl:grid min-h-[500px] mt-4 px-4"><GalleryLarge images={projectData.images} categories={categories} projectId={projectData.id} shouldPrioritizeCoverImage={true} sizes="(max-width: 1024px) 80vw, 70vw" /></div>;
    $[38] = categories;
    $[39] = projectData.id;
    $[40] = projectData.images;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <PromotionalCardsSection pageType="project" className="my-6" slot={0} totalSlots={5} />;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== projectData.availableSUPs) {
    t19 = <SectionContent title="Available Units"><AvailableSUPs sups={projectData.availableSUPs} /></SectionContent>;
    $[43] = projectData.availableSUPs;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <PromotionalCardsSection pageType="project" className="my-6" slot={1} totalSlots={5} />;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  const t21 = projectData.id;
  let t22;
  let t23;
  let t24;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = [];
    t23 = [];
    t24 = [];
    $[46] = t22;
    $[47] = t23;
    $[48] = t24;
  } else {
    t22 = $[46];
    t23 = $[47];
    t24 = $[48];
  }
  const t25 = projectData.images?.[0]?.url || "";
  let t26;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = [];
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = new Date();
    $[50] = t27;
  } else {
    t27 = $[50];
  }
  const t28 = projectData.location;
  let t29;
  if ($[51] !== projectData.projectInfo.approvals) {
    t29 = projectData.projectInfo.approvals ? projectData.projectInfo.approvals.split(", ") : [];
    $[51] = projectData.projectInfo.approvals;
    $[52] = t29;
  } else {
    t29 = $[52];
  }
  let t30;
  if ($[53] !== projectData.projectInfo.documents) {
    t30 = projectData.projectInfo.documents ? projectData.projectInfo.documents.split(", ") : [];
    $[53] = projectData.projectInfo.documents;
    $[54] = t30;
  } else {
    t30 = $[54];
  }
  let t31;
  if ($[55] !== projectData.projectInfo.bankApprovals) {
    t31 = projectData.projectInfo.bankApprovals ? projectData.projectInfo.bankApprovals.split(", ") : [];
    $[55] = projectData.projectInfo.bankApprovals;
    $[56] = t31;
  } else {
    t31 = $[56];
  }
  let t32;
  if ($[57] !== projectData.amenities) {
    t32 = projectData.amenities || [];
    $[57] = projectData.amenities;
    $[58] = t32;
  } else {
    t32 = $[58];
  }
  let t33;
  if ($[59] !== t32) {
    t33 = t32.map(_temp2);
    $[59] = t32;
    $[60] = t33;
  } else {
    t33 = $[60];
  }
  let t34;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = [];
    $[61] = t34;
  } else {
    t34 = $[61];
  }
  const t35 = projectData.ageStatus?.label === "Age" ? "Ready to move" : "UnderConstruction";
  let t36;
  if ($[62] !== t35) {
    t36 = [t35];
    $[62] = t35;
    $[63] = t36;
  } else {
    t36 = $[63];
  }
  let t37;
  if ($[64] !== projectData.id || $[65] !== projectData.location || $[66] !== projectData.projectInfo.blocks || $[67] !== projectData.projectInfo.maxFloors || $[68] !== projectData.projectInfo.units || $[69] !== t25 || $[70] !== t29 || $[71] !== t30 || $[72] !== t31 || $[73] !== t33 || $[74] !== t36) {
    t37 = {
      _id: t21,
      bathrooms: t22,
      bedrooms: t23,
      builtUpAreas: t24,
      cover: t25,
      distance: 0,
      prices: t26,
      type: "sp",
      updatedAt: t27,
      locality: t28,
      approvals: t29,
      documents: t30,
      bankApprovals: t31,
      amenities: t33,
      totalBlocks: projectData.projectInfo.blocks,
      totalFloors: projectData.projectInfo.maxFloors,
      totalUnits: projectData.projectInfo.units,
      configurations: t34,
      possessionStatuses: t36
    };
    $[64] = projectData.id;
    $[65] = projectData.location;
    $[66] = projectData.projectInfo.blocks;
    $[67] = projectData.projectInfo.maxFloors;
    $[68] = projectData.projectInfo.units;
    $[69] = t25;
    $[70] = t29;
    $[71] = t30;
    $[72] = t31;
    $[73] = t33;
    $[74] = t36;
    $[75] = t37;
  } else {
    t37 = $[75];
  }
  const t38 = projectData.ageStatus?.label + ": " + projectData.ageStatus?.value;
  let t39;
  if ($[76] !== projectData.propertyType) {
    t39 = projectData.propertyType?.map(toSentenceCase).join(", ") || undefined;
    $[76] = projectData.propertyType;
    $[77] = t39;
  } else {
    t39 = $[77];
  }
  const t40 = projectData.rera?.id;
  let t41;
  if ($[78] !== projectData.area || $[79] !== projectData.roads || $[80] !== projectData.specifications || $[81] !== t39 || $[82] !== t40) {
    t41 = {
      propertyType: t39,
      specifications: projectData.specifications,
      area: projectData.area,
      roads: projectData.roads,
      reraId: t40
    };
    $[78] = projectData.area;
    $[79] = projectData.roads;
    $[80] = projectData.specifications;
    $[81] = t39;
    $[82] = t40;
    $[83] = t41;
  } else {
    t41 = $[83];
  }
  let t42;
  if ($[84] !== projectData.projectInfo.waterSource || $[85] !== t37 || $[86] !== t38 || $[87] !== t41) {
    t42 = <SectionContent title="Project Details"><ProjectDetails supOne={t37} isProjectPage={true} waterSourceString={projectData.projectInfo.waterSource} ageString={t38} projectData={t41} /></SectionContent>;
    $[84] = projectData.projectInfo.waterSource;
    $[85] = t37;
    $[86] = t38;
    $[87] = t41;
    $[88] = t42;
  } else {
    t42 = $[88];
  }
  let t43;
  if ($[89] !== projectData.amenities) {
    t43 = projectData.amenities || [];
    $[89] = projectData.amenities;
    $[90] = t43;
  } else {
    t43 = $[90];
  }
  let t44;
  if ($[91] !== t43) {
    t44 = t43.map(_temp3);
    $[91] = t43;
    $[92] = t44;
  } else {
    t44 = $[92];
  }
  let t45;
  if ($[93] !== t44) {
    t45 = <SectionContent title="Amenities"><AmenitiesSection amenities={t44} /></SectionContent>;
    $[93] = t44;
    $[94] = t45;
  } else {
    t45 = $[94];
  }
  let t46;
  if ($[95] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <PromotionalCardsSection pageType="project" className="my-6" slot={2} totalSlots={5} />;
    $[95] = t46;
  } else {
    t46 = $[95];
  }
  let t47;
  if ($[96] !== projectData.additionalFeatures) {
    t47 = (projectData.additionalFeatures || []).length > 0 && <SectionContent title="Additional Features"><AdditionalFeatures additionalFeatures={projectData.additionalFeatures || []} /></SectionContent>;
    $[96] = projectData.additionalFeatures;
    $[97] = t47;
  } else {
    t47 = $[97];
  }
  let t48;
  if ($[98] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = <PromotionalCardsSection pageType="project" className="my-6" slot={3} totalSlots={5} />;
    $[98] = t48;
  } else {
    t48 = $[98];
  }
  let t49;
  if ($[99] !== coordinates) {
    t49 = coordinates && <LazyNearbyPlacesMap center={coordinates} coordinates={[coordinates.lng, coordinates.lat]} className="mb-6" />;
    $[99] = coordinates;
    $[100] = t49;
  } else {
    t49 = $[100];
  }
  let t50;
  if ($[101] !== t49) {
    t50 = <SectionContent title="Nearby Places">{t49}</SectionContent>;
    $[101] = t49;
    $[102] = t50;
  } else {
    t50 = $[102];
  }
  let t51;
  if ($[103] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = <PromotionalCardsSection pageType="project" className="my-6" slot={4} totalSlots={5} />;
    $[103] = t51;
  } else {
    t51 = $[103];
  }
  let t52;
  if ($[104] !== coordinates || $[105] !== id || $[106] !== nearByProjects || $[107] !== projectData.name) {
    t52 = coordinates && <LazySection rootMargin="150px" threshold={0.1} fallback={<NearbySupsSkeleton />} ssrShowChildren={true}><NearbySUPsClient coordinates={coordinates} initialData={nearByProjects} distanceText={projectData.name} type="sp" excludeId={id} shouldPrioritizeCoverImage={false} /></LazySection>;
    $[104] = coordinates;
    $[105] = id;
    $[106] = nearByProjects;
    $[107] = projectData.name;
    $[108] = t52;
  } else {
    t52 = $[108];
  }
  let t53;
  if ($[109] !== t52) {
    t53 = <SectionContent title="Nearby Projects">{t52}</SectionContent>;
    $[109] = t52;
    $[110] = t53;
  } else {
    t53 = $[110];
  }
  let t54;
  if ($[111] !== t15 || $[112] !== t16 || $[113] !== t17 || $[114] !== t19 || $[115] !== t42 || $[116] !== t45 || $[117] !== t47 || $[118] !== t50 || $[119] !== t53) {
    t54 = <>{t15}{t16}{t17}{t18}{t19}{t20}{t42}{t45}{t46}{t47}{t48}{t50}{t51}{t53}</>;
    $[111] = t15;
    $[112] = t16;
    $[113] = t17;
    $[114] = t19;
    $[115] = t42;
    $[116] = t45;
    $[117] = t47;
    $[118] = t50;
    $[119] = t53;
    $[120] = t54;
  } else {
    t54 = $[120];
  }
  return t54;
}
function _temp3(x) {
  return x.name;
}
function _temp2(a_0) {
  return a_0.code;
}
function _temp(a) {
  return a.code;
}